import { FETCH_DASHBOARD, FETCH_DASHBOARD_SUCCESS, FETCH_DASHBOARD_FAILURE }
  from '../actions/Dashboard'

const initialState = {
  charts: null,
  error: null,
  loading: false
}

export default function dashboard (state = initialState, action) {
  switch (action.type) {
    case FETCH_DASHBOARD:
      return {...state, loading: true, error: null, charts: null}
    case FETCH_DASHBOARD_SUCCESS:
      return {...state, charts: action.payload, loading: false, error: null}
    case FETCH_DASHBOARD_FAILURE:
      return {...state, error: action.payload, loading: false, charts: null}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dashboard.js